var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllGamesWeb = function SvgIllGamesWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1259,
    height: 395,
    viewBox: "0 0 1259 395",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M901.113 67.5071L908.402 68.8552L942.575 69.0723L929.07 66.9473L901.113 67.5071Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M943.74 13.7188L933.537 38.4652C933.537 38.4652 942.14 41.5271 946.527 29.9879C948.675 19.237 943.74 13.7188 943.74 13.7188Z",
    fill: "#ED1B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M895.287 2.43038C895.287 2.43038 919.508 3.86993 937.525 8.80553L926.442 35.5057L886.832 27.5311C886.832 27.5311 891.162 12.2216 895.298 2.41895L895.287 2.43038Z",
    fill: "#0066FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M871.614 25.874L868.609 63.7821L908.345 68.3407L930.224 68.3407L930.224 33.563L909.385 31.4723L871.614 25.874Z",
    fill: "#F6D638",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M878.538 26.9023L906.3 31.0153L903.696 67.8038L875.979 64.6276L878.538 26.9023Z",
    fill: "#ED1B98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M924.385 32.9805L923.848 68.3408L913.383 68.3408L914.971 32.0322L924.385 32.9805Z",
    fill: "#ED1B98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M897.227 41.6681C897.681 38.1066 895.882 34.9434 893.209 34.6029C890.536 34.2624 888.002 36.8736 887.548 40.4351C887.094 43.9966 888.893 47.1598 891.566 47.5003C894.239 47.8408 896.773 45.2296 897.227 41.6681Z",
    fill: "#F6D638"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M892.088 36.1914C892.088 36.1914 889.129 37.0826 889.094 41.047C889.06 45.0115 890.705 45.7655 891.745 45.9598C891.745 45.9598 893.447 46.5996 894.464 44.5202",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M937.526 8.80566L943.741 13.7184L933.538 38.4649L926.443 35.5173L937.526 8.80566Z",
    fill: "#F6D638"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M915.486 11.6622C915.486 11.6622 913.898 -0.368344 923.963 0.00868054C934.029 0.385705 931.184 13.5701 925.825 15.4895C925.825 15.4895 921.827 16.9291 920.787 19.7967L915.806 18.1173C915.806 18.1173 916.137 14.2328 915.474 11.6622L915.486 11.6622Z",
    fill: "#F6D638"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M908.998 31.4156L913.385 22.4355L919.189 24.8119L915.922 32.0325L908.998 31.4156Z",
    fill: "#F6D638"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M910.128 21.59L922.89 26.8341C923.004 26.8798 923.118 26.914 923.244 26.9369C923.952 27.0397 926.283 27.1997 927.151 24.8004C928.191 21.9556 925.004 20.9959 925.004 20.9959L912.23 16.026C911.831 15.8661 911.374 15.8775 910.985 16.0603C910.38 16.3574 909.534 16.9972 909.123 18.3225C908.654 19.8191 909.169 20.7446 909.534 21.1787C909.694 21.3615 909.888 21.4986 910.105 21.5786L910.128 21.59Z",
    fill: "#F6D638"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M915.865 17.4433L920.961 19.4313L915.888 16.7578",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M909.865 21.4531L923.05 26.9942",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M912.094 25.1096L913.076 22.8018L916.961 24.8125L912.996 24.3098L915.738 25.6466",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M875.773 27.3376L874.985 8.40644C874.973 8.02941 875.327 7.74378 875.693 7.84661C877.075 8.20078 880.229 9.57178 883.69 14.9872L895.79 7.04686C896.178 6.78409 896.715 6.98975 896.841 7.43533L900.405 20.0828L908.3 14.8844C908.62 14.6673 909.043 14.953 908.974 15.33L905.946 31.542L875.762 27.3376L875.773 27.3376Z",
    fill: "#F6D638"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M874.984 13.7188L883.028 20.9051L893.15 15.0897L899.754 25.8749L907.683 22.2646",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M883.701 40.1337C885.67 40.1337 887.266 38.5685 887.266 36.6376C887.266 34.7068 885.67 33.1416 883.701 33.1416C881.733 33.1416 880.137 34.7068 880.137 36.6376C880.137 38.5685 881.733 40.1337 883.701 40.1337Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M891.55 32.0331C893.614 32.0331 895.286 30.4167 895.286 28.4228C895.286 26.4289 893.614 24.8125 891.55 24.8125C889.487 24.8125 887.814 26.4289 887.814 28.4228C887.814 30.4167 889.487 32.0331 891.55 32.0331Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M887.266 33.3245C888.944 33.3245 890.305 31.8309 890.305 29.9884C890.305 28.146 888.944 26.6523 887.266 26.6523C885.587 26.6523 884.227 28.146 884.227 29.9884C884.227 31.8309 885.587 33.3245 887.266 33.3245Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M882.81 48.3481C884.759 48.3481 886.34 46.7113 886.34 44.6921C886.34 42.673 884.759 41.0361 882.81 41.0361C880.86 41.0361 879.279 42.673 879.279 44.6921C879.279 46.7113 880.86 48.3481 882.81 48.3481Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M881.29 55.9567C883.284 55.9567 884.9 54.4324 884.9 52.5521C884.9 50.6718 883.284 49.1475 881.29 49.1475C879.296 49.1475 877.68 50.6718 877.68 52.5521C877.68 54.4324 879.296 55.9567 881.29 55.9567Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M879.681 63.0632C881.53 63.0632 883.029 61.5645 883.029 59.7157C883.029 57.8669 881.53 56.3682 879.681 56.3682C877.833 56.3682 876.334 57.8669 876.334 59.7157C876.334 61.5645 877.833 63.0632 879.681 63.0632Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M874.962 68.3417C876.697 68.3417 878.104 66.8276 878.104 64.9599C878.104 63.0922 876.697 61.5781 874.962 61.5781C873.227 61.5781 871.82 63.0922 871.82 64.9599C871.82 66.8276 873.227 68.3417 874.962 68.3417Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M863.982 65.5312C865.629 65.5312 866.964 64.0938 866.964 62.3208C866.964 60.5477 865.629 59.1104 863.982 59.1104C862.335 59.1104 861 60.5477 861 62.3208C861 64.0938 862.335 65.5312 863.982 65.5312Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M868.861 71.1526C870.678 71.1526 872.151 69.5823 872.151 67.6452C872.151 65.7081 870.678 64.1377 868.861 64.1377C867.043 64.1377 865.57 65.7081 865.57 67.6452C865.57 69.5823 867.043 71.1526 868.861 71.1526Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M869.318 61.7269C870.883 61.7269 872.151 60.3868 872.151 58.7336C872.151 57.0804 870.883 55.7402 869.318 55.7402C867.753 55.7402 866.484 57.0804 866.484 58.7336C866.484 60.3868 867.753 61.7269 869.318 61.7269Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M356.047 79.6717L383.483 79.6717L364.593 77.5596L356.047 79.6717Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M357.834 79.6721C369.894 79.6721 379.67 69.8957 379.67 57.836C379.67 45.7763 369.894 36 357.834 36C345.774 36 335.998 45.7763 335.998 57.836C335.998 69.8957 345.774 79.6721 357.834 79.6721Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M366.304 49.8857C342.475 50.0266 335.998 57.8251 335.998 57.8251C337.027 77.4732 354.92 79.4662 354.92 79.4662C358.852 61.8869 368.817 55.4097 368.817 55.4097L366.304 49.8857V49.8857Z",
    fill: "#ED1B98"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M348.822 37.9389C348.822 37.9389 359.405 40.5817 366.304 49.8858C366.304 49.5176 372.868 50.1458 372.868 50.1458C372.868 50.1458 371.72 42.8779 368.34 38.6754C368.34 38.6754 359.058 33.303 348.822 37.928L348.822 37.9389Z",
    fill: "#ED1B98"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.366 73.1837C373.366 73.1837 374.763 59.8828 368.816 55.4203L370.679 49.8096C370.679 49.8096 376.842 49.2356 379.29 53.7631C379.29 53.7631 382.215 64.7353 373.366 73.1946L373.366 73.1837Z",
    fill: "#ED1B98"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M371.078 55.4789C372.898 54.8324 373.755 52.5626 372.99 50.4092C372.225 48.2558 370.129 47.0343 368.309 47.6809C366.488 48.3274 365.632 50.5972 366.396 52.7506C367.161 54.904 369.257 56.1255 371.078 55.4789Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M133.998 110.684C133.998 110.684 133.771 108.787 130.089 107.614C126.407 106.442 119.381 103.256 122.69 98.9496C122.69 98.9496 124.944 97.0063 126.997 100.61C129.05 104.214 130.412 105.325 130.134 104.452C129.856 103.579 128.49 101.45 126.891 97.4388C125.291 93.4272 121.924 86.8883 126.221 83.8129C130.517 80.7375 131.871 87.4948 131.118 89.6579C130.365 91.821 129.497 94.9138 129.893 97.0195C130.29 99.1253 130.823 102.95 130.765 101.584C130.707 100.217 130.371 99.523 130.818 96.7247C131.093 94.9313 132.047 93.7228 134.159 94.1713C136.271 94.6198 136.072 99.8461 134.104 102.866C132.136 105.886 136.08 107.879 136.221 108.681C136.362 109.483 137.71 110.336 133.984 110.677L133.998 110.684Z",
    fill: "#32BF5E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.61 101.228C1243.61 101.228 1244.28 99.8643 1244.75 99.8949C1245.21 99.9255 1246.64 100.625 1248.82 100.214C1250.99 99.8032 1252.66 98.4388 1251.49 97.0247C1250.32 95.6106 1247.11 96.3204 1245.92 97.9754C1245.92 97.9754 1246.33 96.454 1246.91 95.8791C1247.48 95.3043 1250.14 95.0107 1252.03 94.0403C1253.92 93.0699 1255.17 91.7875 1254.56 89.8728C1253.94 87.9581 1251.33 89.6158 1250.22 91.7885C1249.76 92.4568 1248.97 94.0501 1248.05 93.954C1248.69 93.4445 1249.54 90.0235 1252.84 87.1855C1256.14 84.3475 1257.51 81.2532 1255.44 80.4025C1253.37 79.5518 1252.51 81.8755 1252.04 84.0992C1251.57 86.3228 1251.39 86.8168 1250.02 88.6135C1248.64 90.4102 1247.23 92.5086 1247.1 92.8C1246.98 93.0914 1246.94 92.1528 1248.05 90.1759C1249.53 87.5363 1250.34 85.6301 1248.16 85.2543C1245.99 84.8786 1244.55 88.2993 1245.17 91.515C1245.78 94.6395 1245.28 94.5729 1244.46 96.3867C1244.46 96.3867 1244.22 96.6578 1244.5 94.6986C1244.79 92.7393 1244.1 89.8803 1242.72 89.8572C1241.34 89.834 1240.38 93.5836 1241.65 96.0782C1242.93 98.5727 1243.06 98.9836 1242.85 99.3684C1242.63 99.7532 1242.11 100.575 1242.11 100.575C1242.11 100.575 1242.7 101.646 1243.62 101.22L1243.61 101.228Z",
    fill: "#32BF5E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M809.27 164.949C809.27 164.949 812.526 165.554 814.225 162.591C815.924 159.628 817.249 160.084 817.83 156.208C818.41 152.333 817.424 151.641 815.924 151.964C814.424 152.286 812.883 154.817 812.883 160.099C812.709 161.09 812.427 161.726 812.443 161.656C812.584 161.058 813.355 156.947 811.176 153.339C809.518 150.596 806.9 148.151 804.853 149.283C802.806 150.415 804.737 153.363 807.455 156.963C807.455 156.963 811.872 161.773 811.018 162.685C810.165 163.597 809.286 164.949 809.286 164.949L809.27 164.949Z",
    fill: "#32BF5E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0495 361.438C79.0495 361.438 83.7615 359.313 83.1034 353.814C82.4453 348.314 84.5627 347.729 81.6171 342.017C78.6716 336.305 76.7616 336.267 75.1626 338.051C73.5636 339.835 74.0109 344.613 79.0303 351.687C79.7504 353.17 79.9976 354.277 79.9514 354.167C79.5627 353.24 76.6351 347.04 70.4382 344.173C65.7262 341.993 60.0769 341.08 58.5526 344.441C57.0282 347.801 62.2818 350.008 69.1554 352.379C69.1554 352.379 79.3371 354.84 79.1194 356.831C78.9016 358.821 79.0706 361.423 79.0706 361.423L79.0495 361.438Z",
    fill: "#32BF5E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.61 125.28L1106.87 130.212C1106.73 130.455 1106.73 130.731 1106.85 130.968L1109.19 135.407C1109.5 136.004 1108.96 136.704 1108.26 136.602L1103.13 135.781C1102.85 135.734 1102.57 135.822 1102.36 136.019L1098.24 140.606C1097.74 141.089 1096.89 140.826 1096.81 140.159L1096.55 134.215C1096.52 133.953 1096.34 133.723 1096.1 133.6L1089.72 130.928C1089.09 130.637 1089.11 129.766 1089.75 129.464L1096.24 127.69C1096.49 127.574 1096.67 127.338 1096.71 127.07L1097.59 122.094C1097.7 121.422 1098.57 121.153 1099.05 121.629L1102.62 125.21C1102.82 125.404 1103.09 125.492 1103.37 125.44L1109.74 124.088C1110.44 123.976 1110.96 124.663 1110.61 125.27L1110.61 125.28Z",
    fill: "#2FCDF2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M216.511 122.123C216.974 122.123 217.35 121.748 217.35 121.284C217.35 120.821 216.974 120.445 216.511 120.445C216.047 120.445 215.672 120.821 215.672 121.284C215.672 121.748 216.047 122.123 216.511 122.123Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M219.582 124.266C219.874 124.266 220.111 124.029 220.111 123.737C220.111 123.445 219.874 123.208 219.582 123.208C219.29 123.208 219.053 123.445 219.053 123.737C219.053 124.029 219.29 124.266 219.582 124.266Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M213.425 221.146C213.995 221.146 214.458 220.684 214.458 220.114C214.458 219.543 213.995 219.081 213.425 219.081C212.855 219.081 212.393 219.543 212.393 220.114C212.393 220.684 212.855 221.146 213.425 221.146Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M210.781 215.054C211.151 215.054 211.452 214.754 211.452 214.383C211.452 214.012 211.151 213.712 210.781 213.712C210.41 213.712 210.109 214.012 210.109 214.383C210.109 214.754 210.41 215.054 210.781 215.054Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M144.206 225.367C144.89 225.367 145.445 224.812 145.445 224.128C145.445 223.443 144.89 222.889 144.206 222.889C143.522 222.889 142.967 223.443 142.967 224.128C142.967 224.812 143.522 225.367 144.206 225.367Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M118.391 302.809C119.076 302.809 119.63 302.254 119.63 301.57C119.63 300.886 119.076 300.331 118.391 300.331C117.707 300.331 117.152 300.886 117.152 301.57C117.152 302.254 117.707 302.809 118.391 302.809Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22736 289.903C2.91168 289.903 3.46644 289.348 3.46644 288.664C3.46644 287.98 2.91168 287.425 2.22736 287.425C1.54303 287.425 0.988281 287.98 0.988281 288.664C0.988281 289.348 1.54303 289.903 2.22736 289.903Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1336 394.451C15.8179 394.451 16.3727 393.607 16.3727 392.566C16.3727 391.525 15.8179 390.682 15.1336 390.682C14.4493 390.682 13.8945 391.525 13.8945 392.566C13.8945 393.607 14.4493 394.451 15.1336 394.451Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M341.412 191.37C342.217 191.37 342.87 190.717 342.87 189.912C342.87 189.106 342.217 188.453 341.412 188.453C340.606 188.453 339.953 189.106 339.953 189.912C339.953 190.717 340.606 191.37 341.412 191.37Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M345.312 184.439C345.939 184.439 346.447 183.93 346.447 183.303C346.447 182.676 345.939 182.167 345.312 182.167C344.684 182.167 344.176 182.676 344.176 183.303C344.176 183.93 344.684 184.439 345.312 184.439Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M408.167 54.632C408.794 54.632 409.303 54.1235 409.303 53.4962C409.303 52.8689 408.794 52.3604 408.167 52.3604C407.54 52.3604 407.031 52.8689 407.031 53.4962C407.031 54.1235 407.54 54.632 408.167 54.632Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M410.8 59.0851C411.263 59.0851 411.639 58.7095 411.639 58.2462C411.639 57.7829 411.263 57.4072 410.8 57.4072C410.337 57.4072 409.961 57.7829 409.961 58.2462C409.961 58.7095 410.337 59.0851 410.8 59.0851Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M433.956 54.4135C434.291 54.4135 434.563 54.1419 434.563 53.8068C434.563 53.4718 434.291 53.2002 433.956 53.2002C433.621 53.2002 433.35 53.4718 433.35 53.8068C433.35 54.1419 433.621 54.4135 433.956 54.4135Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M664.4 219.017C664.735 219.017 665.006 218.745 665.006 218.41C665.006 218.075 664.735 217.804 664.4 217.804C664.065 217.804 663.793 218.075 663.793 218.41C663.793 218.745 664.065 219.017 664.4 219.017Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M489.339 139.768C489.674 139.768 489.946 139.496 489.946 139.161C489.946 138.826 489.674 138.555 489.339 138.555C489.004 138.555 488.732 138.826 488.732 139.161C488.732 139.496 489.004 139.768 489.339 139.768Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M433.956 54.4135C434.291 54.4135 434.563 54.1419 434.563 53.8068C434.563 53.4718 434.291 53.2002 433.956 53.2002C433.621 53.2002 433.35 53.4718 433.35 53.8068C433.35 54.1419 433.621 54.4135 433.956 54.4135Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M528.966 52.4769C529.301 52.4769 529.573 52.2053 529.573 51.8703C529.573 51.5353 529.301 51.2637 528.966 51.2637C528.631 51.2637 528.359 51.5353 528.359 51.8703C528.359 52.2053 528.631 52.4769 528.966 52.4769Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M816.662 100.776C817.389 100.776 817.979 100.186 817.979 99.4591C817.979 98.732 817.389 98.1426 816.662 98.1426C815.935 98.1426 815.346 98.732 815.346 99.4591C815.346 100.186 815.935 100.776 816.662 100.776Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M762.633 54.7356C763.246 54.7356 763.743 54.2387 763.743 53.6256C763.743 53.0126 763.246 52.5156 762.633 52.5156C762.02 52.5156 761.523 53.0126 761.523 53.6256C761.523 54.2387 762.02 54.7356 762.633 54.7356Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M885.084 196.248C885.811 196.248 886.401 195.659 886.401 194.932C886.401 194.205 885.811 193.615 885.084 193.615C884.357 193.615 883.768 194.205 883.768 194.932C883.768 195.659 884.357 196.248 885.084 196.248Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M977.821 110.03C978.342 110.03 978.763 109.608 978.763 109.088C978.763 108.567 978.342 108.146 977.821 108.146C977.301 108.146 976.879 108.567 976.879 109.088C976.879 109.608 977.301 110.03 977.821 110.03Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M990.703 110.068C991.109 110.068 991.438 109.739 991.438 109.332C991.438 108.926 991.109 108.597 990.703 108.597C990.296 108.597 989.967 108.926 989.967 109.332C989.967 109.739 990.296 110.068 990.703 110.068Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.99 222.979C1012.39 222.979 1012.72 222.65 1012.72 222.243C1012.72 221.837 1012.39 221.508 1011.99 221.508C1011.58 221.508 1011.25 221.837 1011.25 222.243C1011.25 222.65 1011.58 222.979 1011.99 222.979Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.55 172.577C1064.23 172.577 1064.79 172.022 1064.79 171.338C1064.79 170.653 1064.23 170.099 1063.55 170.099C1062.87 170.099 1062.31 170.653 1062.31 171.338C1062.31 172.022 1062.87 172.577 1063.55 172.577Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.71 288.741C1180.4 288.741 1180.95 288.186 1180.95 287.502C1180.95 286.817 1180.4 286.263 1179.71 286.263C1179.03 286.263 1178.47 286.817 1178.47 287.502C1178.47 288.186 1179.03 288.741 1179.71 288.741Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.81 366.183C1167.49 366.183 1168.05 365.628 1168.05 364.944C1168.05 364.26 1167.49 363.705 1166.81 363.705C1166.12 363.705 1165.57 364.26 1165.57 364.944C1165.57 365.628 1166.12 366.183 1166.81 366.183Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.74 314.554C1038.42 314.554 1038.97 314 1038.97 313.315C1038.97 312.631 1038.42 312.076 1037.74 312.076C1037.05 312.076 1036.5 312.631 1036.5 313.315C1036.5 314 1037.05 314.554 1037.74 314.554Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M282.505 210.292C281.718 213.738 279.782 216.578 275.832 217.12C275.019 217.236 274.309 217.094 273.587 217.546C272.502 218.23 271.96 220.218 270.553 220.063C268.308 219.818 263.067 217.598 262.319 216.036C261.751 214.861 263.029 214.048 262.771 212.68C262.667 212.099 262.538 211.776 262.228 211.286C261.106 209.479 260.654 207.414 261.118 205.387C262.203 200.638 267.882 197.888 273.793 199.231C279.705 200.573 283.615 205.529 282.518 210.279L282.505 210.292Z",
    fill: "#FCAEE0"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M264.41 212.706L270.838 216.578",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M265.082 205.233L266.011 213.675",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M266.889 214.203L273.497 202.393",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M267.998 214.642C268.372 214.294 268.282 214.384 278.04 206.937",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M268.707 215.3L276.606 213.674",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M898.373 117.671C901.234 118.835 903.225 120.587 902.583 123.122C902.453 123.644 902.116 124.058 902.322 124.591C902.616 125.385 904.259 126.114 903.704 126.963C902.834 128.29 899.352 131.086 897.731 131.238C896.524 131.358 896.154 130.411 894.848 130.303C894.293 130.259 893.967 130.27 893.445 130.357C891.497 130.694 889.517 130.564 887.831 129.878C883.881 128.268 883.044 124.232 885.949 120.859C888.864 117.486 894.424 116.05 898.373 117.66L898.373 117.671Z",
    fill: "#FCAEE0"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M895.336 129.301L900.656 126.092",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M888.82 127.408L896.665 128.496",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M897.394 128.061L888.701 121.664",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M898.102 127.474C897.895 127.17 897.949 127.246 894.076 119.771",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M898.895 127.158L899.7 121.969",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M451.356 160.814C452.557 162.414 453.047 164.26 451.743 166.093C451.472 166.467 451.137 166.712 451.046 167.177C450.917 167.874 451.589 168.829 450.956 169.358C449.962 170.197 446.942 171.553 445.961 171.282C445.225 171.088 445.367 170.262 444.657 169.862C444.361 169.694 444.167 169.629 443.831 169.565C442.592 169.358 441.508 168.791 440.798 167.848C439.133 165.641 440.153 162.285 443.057 160.336C445.961 158.387 449.678 158.594 451.343 160.801L451.356 160.814Z",
    fill: "#FCAEE0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M445.316 169.204L449.55 167.965",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M442.102 166.028L446.374 168.894",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M446.957 168.726L444.246 162.763",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M447.574 168.429C447.574 168.145 447.574 167.706 448.129 160.917",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M448.156 168.378L450.531 164.506",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1223.74 365.003C1224.94 366.604 1225.43 368.45 1224.13 370.282C1223.86 370.657 1223.52 370.902 1223.43 371.367C1223.3 372.064 1223.97 373.019 1223.34 373.548C1222.35 374.387 1219.32 375.742 1218.34 375.471C1217.61 375.277 1217.75 374.451 1217.04 374.051C1216.74 373.883 1216.55 373.819 1216.21 373.754C1214.98 373.548 1213.89 372.98 1213.18 372.038C1211.52 369.831 1212.54 366.475 1215.44 364.526C1218.34 362.577 1222.06 362.783 1223.73 364.99L1223.74 365.003Z",
    fill: "#FCAEE0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.7 373.392L1221.93 372.153",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.48 370.218L1218.76 373.083",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.34 372.915L1216.63 366.952",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.96 372.618C1219.96 372.334 1219.96 371.896 1220.51 365.106",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.54 372.566L1222.91 368.694",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllGamesWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_games_web.be7d5e03.svg";
export { ForwardRef as ReactComponent };